import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const agentError = e => typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Controleer de ingevulde gegevens of probeer opnieuw.";
export const roleName = role => role === "AGENT_ADMIN" ? "Beheerder" : "Medewerker";
export const CoreField = ({ id, label, value, onChange, required = false, type = "text", ...props }) => (
  <div className="min-w-0 space-y-2">
    <Label htmlFor={id}>{label}{required ? " *" : ""}</Label>
    <Input id={id} data-testid={id} value={value ?? ""} type={type} required={required}
      onChange={e => onChange(e.target.value)} {...props}/>
  </div>
);
export const CoreError = ({ error, id }) => error ? <p className="core-error" role="alert" data-testid={id}>{error}</p> : null;
export const CoreStatus = ({ value, id }) => <span className="core-status" data-testid={id}>{({nieuw:"Nieuw",in_behandeling:"In behandeling",afgerond:"Afgerond",geannuleerd:"Geannuleerd"})[value] || value}</span>;